import { render, staticRenderFns } from "./UpdatePolicy.vue?vue&type=template&id=32ca3aac&scoped=true&"
import script from "./UpdatePolicy.vue?vue&type=script&lang=js&"
export * from "./UpdatePolicy.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePolicy.vue?vue&type=style&index=0&id=32ca3aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca3aac",
  null
  
)

export default component.exports